<template>
    <div class="page">
        <top-banner :img-url="require('../../assets/img/manpowerResource/talentsBanner.png')"
                    :pageTitle="$i18n.t('common.人才发展')"></top-banner>
            <div class="container">
                <section-title :title="$i18n.t('common.人才发展')" ></section-title>
                <div class="newsswiper">
                    <div class="poster" :style="{'background-image':'url(' +bannerlist[swiperindex].big_picture+ ')'}" v-if="bannerlist.length>0"></div>
                    <section class="banner">
                        <swiper :options="bannerSwiperOpts" ref="bannerSwiper" v-if="bannerlist.length>0">
                            <swiper-slide v-for="(item,index) in bannerlist" :key="index" class="banner-item">
                                <div class="title">{{item.name}}</div>
                                <div class="line"></div>
                                <div class="row contents">
                                    <div class="content" v-html="item.content"></div>
                                    <div class="poster"></div>
                                </div>
                            </swiper-slide>
                        </swiper>
                        <div class="icon-left icon">
                            <Icon type="ios-arrow-back"/>
                        </div>
                        <div class="icon-right">
                            <Icon type="ios-arrow-forward"/>
                        </div>
                    </section>

                    <div class="img-list row" v-if="bannerlist.length>0">
                        <div v-for="(item,index) in bannerlist[swiperindex].picture" class="img-item" :style="{'background-image':'url(' +item+')'}"></div>
                    </div>
                </div>
            </div>
    </div>

</template>

<script>
    let vm
    export default {
        data(){
            return{
                swiperindex:0,
                bannerlist:[],
                bannerSwiperOpts:{
                    loop: true,
                    effect:'slide',
                    speed:800,
                    observer:true,
                    observeParents:true,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                        type: "bullets"
                    },
                    on:{
                        slideChangeTransitionEnd: function(){
                         vm.swiperindex=this.realIndex
                            console.log(this.realIndex)
                        },
                    },
                    autoplay:{
                        delay: 5000,
                    },
                    navigation: {
                        nextEl: '.icon-right',
                        prevEl: '.icon-left',
                    },
                },
            }

        },
        created() {
           vm=this;
        },
        mounted(){
            this.$api.manpowerResource.getTalentsApi().then(res=>{
                this.bannerlist = res|| [];
            });
        }
    }
</script>

<style lang="scss" scoped>
    .page{
        background: #FAFAFA;
    }
    .row{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    /*轮播navigation样式*/
    .icon-left{
        left: -25px;
    }
    .icon{
        position: absolute;
        width: 50px;
        height: 50px;
        top: 50%;
        margin-top: -25px;
        background-color: #fff;
        z-index: 11;
        text-align: center;
        border: 1px solid #007BD8;
        cursor: pointer;
        outline: none;
    &:hover {
         background-color: $primary-color;
    i {
        color: #fff;
    }
    }
    i{
        font-size: 32px;
        color: #007BD8;
        line-height: 50px;
    }
    }
    .icon-right{
    @extend .icon;
        position: absolute;
        top: 50%;
        margin-top: -25px;
        right: -25px;
    }
.newsswiper{
    position: relative;
    margin-bottom: 102px;
    .poster{
        width: 650px;
        height: 650px;
        background-size: cover;
        background-position: center;
    }
    .banner{
        width: 802px;
        min-height: 324px;
        background: #ffffff;
        position: absolute;
        left: 399px;
        top:80px;
        padding:32px 63px;
        .title{
            font-size:$font-size-extra-large;
            color:$subtitle-color;
        }
        .line{
            width: 120px;
            height: 0px;
            border-bottom: 3px solid #1CAAFF;
        }
        .contents{
            align-items: flex-start;
            .content{
                margin-top: 34px;
                font-size: 14px;
                width:415px;
            }
            .poster{
                width: 243px;
                height: 107px;
                background: url("../../assets/img/manpowerResource/bannerbg.png");
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                flex-shrink: 0;
                margin-top: 30px;
            }
        }

    }
}
    .img-list{
        position: absolute;
        left: 707px;
        bottom: 0px;
        width: 495px;
        .img-item{
            width: 154px;
            height: 154px;
            background-size: cover;
            background-position: center;
            flex-shrink: 0;
        }
    }

</style>
